"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const _tagged_template_literal = require("@swc/helpers/_/_tagged_template_literal");
function _templateObject() {
    const data = _tagged_template_literal._([
        "\n  to {\n    transform: rotate(360deg);\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Spinner = exports.Root = void 0;
var _mui = require("@ori-ui/mui");
const spin = (0, _mui.keyframes)(_templateObject());
const Root = exports.Root = (0, _mui.styled)('div')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center'
});
const Spinner = exports.Spinner = (0, _mui.styled)('div')({
    width: 50,
    height: 50,
    animation: "".concat(spin, " 1.5s linear infinite"),
    backgroundImage: "url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIHZpZXdCb3g9IjAgMCA1MCA1MCI+CiAgPGRlZnM+CiAgICA8bGluZWFyR3JhZGllbnQgaWQ9ImxpbmVhci1ncmFkaWVudCIgeDE9Ii0wLjAxOSIgeTE9IjAuNzUiIHgyPSIwLjkxMSIgeTI9IjAuODg3IiBncmFkaWVudFVuaXRzPSJvYmplY3RCb3VuZGluZ0JveCI+CiAgICAgIDxzdG9wIG9mZnNldD0iMCIgc3RvcC1jb2xvcj0iI2JhYzViOSIgc3RvcC1vcGFjaXR5PSIwIi8+CiAgICAgIDxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iI2JhYzViOSIvPgogICAgPC9saW5lYXJHcmFkaWVudD4KICA8L2RlZnM+CiAgPGcgaWQ9Im5vdW5fcHJlbG9hZGVyXzEyNzQxNTciIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMC40MDQgLTEwLjQwNCkiPgogICAgPGcgaWQ9IlN5bWJvbF8xOTFfMSIgZGF0YS1uYW1lPSJTeW1ib2wgMTkxIOKAkyAxIj4KICAgICAgPHBhdGggaWQ9IlBhdGhfMTc5MjAiIGRhdGEtbmFtZT0iUGF0aCAxNzkyMCIgZD0iTTM1LjQyNSw5NjIuNzY2Yy0xMi45NjgsMC0yNS4wMjIsMTEuMTcyLTI1LjAyMiwyNWEyOS45LDI5LjksMCwwLDAsLjI2MSwzLjU2MmMuNDY2LDMuMDU1LDIuMTIzLDMuNzcxLDMuNSwzLjY0OWEyLjQ2MiwyLjQ2MiwwLDAsMCwxLjczOC0uOTEyLDIuNzMsMi43MywwLDAsMCwuNDc4LTIuMjE1Yy0uMDMzLS4xNDItLjA0NS0uMy0uMDY1LS40MzRhMTkuMTY1LDE5LjE2NSwwLDAsMS0uMzkxLTMuNjQ5LDE5LjQ1NiwxOS40NTYsMCwxLDEsMTIuNjg1LDE4LjI0NWMtMy40NjItMS40NjUtNS43MTcsMy4yMTctMi4xOTQsNS4wODNhMjIuNiwyMi42LDAsMCwwLDkuMDE0LDEuNjcyLDI0Ljk3LDI0Ljk3LDAsMCwwLDI0Ljk3OC0yNUM2MC4xNjYsOTczLjI3NCw0Ny43NjQsOTYyLjk3MSwzNS40MjUsOTYyLjc2NloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgLTk1Mi4zNjIpIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGZpbGw9InVybCgjbGluZWFyLWdyYWRpZW50KSIvPgogICAgPC9nPgogIDwvZz4KPC9zdmc+Cg==')"
});
